import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";
export const ReportsIcon: FC<SvgIconConstituentValues> = ({
  fill,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      stroke={fill || "#646965"}
      strokeWidth="2"
    />
    <rect x="7" y="8" width="10" height="2" rx="1" fill={fill || "#646965"} />
    <rect x="7" y="12" width="7" height="2" rx="1" fill={fill || "#646965"} />
    <rect x="7" y="16" width="5" height="2" rx="1" fill={fill || "#646965"} />
  </svg>
);
